@if (data()?.length) {
  <div>
    @for (radio of data(); track radio) {
      <label class="radio">
        <span class="radio__input-group">
          <input
            type="radio"
            [name]="radioName"
            [value]="radio.value"
            [checked]="radio.value === selectedValue()"
            [disabled]="radio.disabled === true"
            (click)="onSelect($event, radio.value, radio.disabled)"
            class="radio__input" />
          <span class="radio__indicator" [ngClass]="{'radio__indicator--disabled': radio.disabled}"></span>
          <span class="radio__label" [ngClass]="{'radio__label--disabled': radio.disabled}">{{'OFFER_STATUSES.' + radio.name | translate}}</span>
        </span>
      </label>
    }
  </div>
}
